import { createSelector } from 'reselect';

import { getVideosGroupedByIds } from './videos';

export function getChannelVideoIds(state) {
  return state.channelVideos.ids;
}

export function isFetching(state) {
  return state.channelVideos.activeRequests !== 0;
}


/**
 * @param state
 * @param channelId {String}
 * @returns {Object[]} videos list
 */
export const getChannelVideosByChannelId = createSelector(
  [
    state => getVideosGroupedByIds(state),
    (state, channelId) => channelId,
  ],
  (videoByIds, channelId) =>
    _.filter(videoByIds, video => _.includes(video.usedInLists, channelId)),
);



// WEBPACK FOOTER //
// ./src/shared/selectors/channel-videos.js